import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Payment, Transaction } from '../../models';
import { environment } from '../../../environments/environment';
import { AlertService } from '../../services/alert.service';
import { DepositComponent } from '../deposit/deposit.component';
import { TransferComponent } from '../transfer/transfer.component';
import {
  BANNER_MESSAGES,
  GENERAL_CONSTANTS,
} from '../../core/constants/General-constants';
import { CONCEPTS } from '../../core/constants/Concepts';
import { FormControl, Validators } from '@angular/forms';
import { PATTERN } from '../../constants/pattern';
import { UserDataModel } from '../../models/userData.model';
import { SubMenuService } from 'src/app/services/sub-menu.service';
import { TokenServiceService } from 'src/app/services/token-service.service';
import { CONSTANTS } from 'src/app/constants/users.constants';
import { RequestUpdateUserName } from 'src/app/models/requestUpdateUserName';
import {
  PAY_METHODS_GU,
  BANK_GU_IDS,
} from 'src/app/core/constants/payMethods-gu';
import { PayvalidaFeatureFlagService } from 'src/app/services/payvalida-feature-flag.service';
import { PaymentMethodsService } from 'src/app/services/payment-methods.service';
import { GeneralTool } from '../split-payment/tools/general-tools';
@Component({
  selector: 'app-sub-menu-gu',
  templateUrl: './sub-menu-gu.component.html',
  styleUrls: ['./sub-menu-gu.component.scss'],
})
export class SubMenuComponentGU implements OnInit {
  @Input() text: string;
  @Input() subText: string;
  @Input() paymentsSubMenuGU: Payment[];
  @Input() transaction: Transaction;
  @Input() visibleReturnPayMethods: boolean;
  @Input() flagActive: boolean;
  @Output() outPutSubMenuGUEmitter = new EventEmitter();

  @ViewChild(DepositComponent) deposit: DepositComponent;
  @ViewChild(TransferComponent) transfer: TransferComponent;
  formPrivacyValid: boolean;
  fullName: string = '';
  merchantHasWallet: boolean;

  private flag = 'recommendationBannersForPaymentMethodsFF';
  private platform = 'payvalida';
  bannerRecommedationFF: boolean = false;
  bannerText: string;

  private parameter2 = 'bannerRecommedationUiFixFF';
  private flag2 = 'bannerRecommedationUiFixFF';
  private platform2 = 'payvalida';
  bannerRecommedationUiFixFF: boolean = false;

  constructor(
    private readonly alertService: AlertService,
    private readonly subMenuService: SubMenuService,
    private readonly tokenServiceService: TokenServiceService,
    private readonly paymentMethodsService: PaymentMethodsService,
    private featureFlagService: PayvalidaFeatureFlagService
  ) {}

  loading: boolean;
  valid = false;
  logo: string;
  visualizeSubMenu = true;
  visualizeUserForm = false;
  visualizePayWeb = false;
  visualizeCash = false;
  visualizeDeposit = false;
  visualizeTransfer = false;
  checkbox = false;
  payment: Payment;
  readonly paymentsMethods = PAY_METHODS_GU;
  readonly bankIds = BANK_GU_IDS;
  readonly CONCEPTS = CONCEPTS;
  public enableContinue = false;
  public userDataModel: UserDataModel;
  buttonEnabledInSubMenu: boolean = false;

  fullNameFormControl = new FormControl('', [
    Validators.required,
    Validators.minLength(4),
    Validators.maxLength(50),
    Validators.pattern(PATTERN.CHARACTERS_SPACE_CHARACTERS),
  ]);

  ngOnInit() {
    const token = this.tokenServiceService.getToken();

    this.featureFlagService
      .getFeatureFlagValue(this.parameter2, this.flag2, this.platform2)
      .subscribe((response: boolean) => {
        this.bannerRecommedationUiFixFF = response;
    });

    this.paymentMethodsService.paymentMethods(token).subscribe((data: any) => {
      const merchantHasWallet = GeneralTool.checkMerchantHasWallet(data);

      if (merchantHasWallet) {
        this.merchantHasWallet = true;
      }
    });

    this.userDataModel = new UserDataModel();
    this.visualizeUserForm = this.flagActive && !this.transaction.USER_NAME;

    this.paymentsSubMenuGU.sort((x, y) => x[GENERAL_CONSTANTS.PRIORITY] - y[GENERAL_CONSTANTS.PRIORITY]);

    for (let payment of this.paymentsSubMenuGU) {
      this.featureFlagService
        .getFeatureFlagValue(`${payment.code}_gu_banners`, this.flag, this.platform)
        .subscribe((response: boolean) => {
          this.bannerRecommedationFF = response;
      });

      if (
        payment.code === BANK_GU_IDS.BAM_PAY_WEB ||
        payment.code === BANK_GU_IDS.BAM_DEPOSIT ||
        payment.code === BANK_GU_IDS.BAM_TRANSFER
      ) {
        this.logo = environment.logo_bam_gu;

        break;
      }

      if (
        payment.code === BANK_GU_IDS.BI_DEPOSIT_B ||
        payment.code === BANK_GU_IDS.BI_DEPOSIT ||
        payment.code === BANK_GU_IDS.BI_TRANSFER
      ) {
        this.logo = environment.logo_bi_gu;

        break;
      }
    }
  }

  /**
   * @description changeMethod Function to switch to view of payment methods
   */
  changeMethod() {
    this.outPutSubMenuGUEmitter.emit();
  }

  /**
   * @description in charge of controlling which view the sub-menu directs to
   * @param payment user selected payment method information
   */
  methods(payment: Payment) {
    this.payment = payment;
    this.visualizeSubMenu = false;
    switch (payment.code) {
      case this.bankIds.BAM_PAY_WEB:
        this.visualizeDeposit = false;
        this.visualizePayWeb = true;
        this.visualizeTransfer = false;
        this.visualizeCash = false;
        break;
      case this.bankIds.BAM_CASH:
        this.visualizeDeposit = false;
        this.visualizePayWeb = false;
        this.visualizeTransfer = false;
        this.visualizeCash = true;
        this.bannerText = BANNER_MESSAGES.CASH_RECOMMENDATION;
        break;
      case this.bankIds.BAM_DEPOSIT:
        this.visualizeDeposit = true;
        this.visualizePayWeb = false;
        this.visualizeTransfer = false;
        this.visualizeCash = false;
        this.bannerText = BANNER_MESSAGES.DEPOSIT_RECOMENDATION;
        break;
      case this.bankIds.BAM_TRANSFER:
        this.visualizeDeposit = false;
        this.visualizePayWeb = false;
        this.visualizeTransfer = true;
        this.visualizeCash = false;
        this.bannerText = BANNER_MESSAGES.DEPOSIT_RECOMENDATION;
        break;
      case this.bankIds.BI_TRANSFER:
        this.visualizeDeposit = false;
        this.visualizePayWeb = false;
        this.visualizeTransfer = true;
        this.visualizeCash = false;
        this.bannerText = BANNER_MESSAGES.DEPOSIT_RECOMENDATION;
        break;
      case this.bankIds.BI_DEPOSIT:
        this.visualizeDeposit = true;
        this.visualizePayWeb = false;
        this.visualizeTransfer = false;
        this.visualizeCash = false;
        this.bannerText = BANNER_MESSAGES.DEPOSIT_RECOMENDATION;
        break;
      case this.bankIds.BI_DEPOSIT_B:
        this.visualizeDeposit = true;
        this.visualizePayWeb = false;
        this.visualizeTransfer = false;
        this.visualizeCash = false;
        this.bannerText = BANNER_MESSAGES.DEPOSIT_RECOMENDATION;
        break;
      default:
        this.alertService.showAlertProblem();
        break;
    }
  }

  /**
   * @description send email to user
   */
  sendEmailToUser() {
    switch (this.payment.code) {
      case this.bankIds.BAM_DEPOSIT:
      case this.bankIds.BI_DEPOSIT:
      case this.bankIds.BI_DEPOSIT_B:
        this.deposit.sendEmail();
        break;
      case this.bankIds.BAM_TRANSFER:
      case this.bankIds.BI_TRANSFER:
        this.transfer.sendEmail();
        break;
      default:
        this.alertService.showPopup(
          '¡Gracias!',
          `Recuerda que tienes hasta ${this.transaction.EXPIRATION} para realizar tu pago`,
          'success',
          'Aceptar'
        );
    }
  }

  /**
   * @description helper function that helps to know about form events
   */
  setInfo(concept) {
    if (concept === CONCEPTS.TRANSFER) {
      this.transfer.emailForm.valueChanges.subscribe((v) => this.checkForms());
      this.transfer.copiesComponents.forEach((c) =>
        c.onCopy.subscribe(() => {
          this.checkForms();
        })
      );
    }
    if (concept === CONCEPTS.DEPOSIT) {
      this.deposit.emailForm.valueChanges.subscribe((v) => this.checkForms());
    }
  }

  /**
   *
   * @description {formPrivacyUpdate} Function that obtains the event of the validation of the child component
   * @param valid
   */
  formPrivacyUpdate = (valid: boolean) => {
    this.formPrivacyValid = valid;
    this.fullName = this.fullNameFormControl.value;
    if (valid && this.fullNameFormControl.valid) {
      this.loading = true;
      this.updateUserNameInOrder(this.fullName);
    }
  };
  /**
   *
   * @description {completedForms} Function to validate the validations of the parent component and child component
   * @returns
   */
  completedForms = (): boolean => {
    return (
      this.formPrivacyValid &&
      this.fullName !== '' &&
      this.fullNameFormControl.valid
    );
  };

  /**
   * @description Verify that the form has been filled out correctly
   */
  checkForms() {
    if (
      this.bankIds.BAM_DEPOSIT === this.payment.code ||
      this.bankIds.BI_DEPOSIT === this.payment.code
    ) {
      this.valid = this.deposit.emailForm.valid;
    } else if (
      this.bankIds.BAM_TRANSFER === this.payment.code ||
      this.bankIds.BI_TRANSFER === this.payment.code
    ) {
      this.valid = this.transfer.emailForm.valid;
    }
  }
  /**
   *
   * @description {updateUserNameInOrder} Function to update the username of the order
   * @param userFullName user's full name
   */
  updateUserNameInOrder(userFullName: string) {
    let requestBody: RequestUpdateUserName = { UserName: userFullName };
    this.subMenuService
      .updateUserNameInOrder(this.tokenServiceService.getToken(), requestBody)
      .subscribe(
        (response) => {
          this.enableContinue = response.CODE == CONSTANTS.CODE_OK;
          this.loading = false;
        },
        (error) => {
          this.alertService.showPopup(
            CONSTANTS.ACTION_ERROR,
            CONSTANTS.USER_UPDATE_ERROR,
            'error',
            CONSTANTS.ALERT_SERVICE_BUTTON_ACCEPT
          );
          this.loading = false;
        }
      );
  }

  /**
   *
   * @description {handleButtonStateChange} Function to update the send button if the validations are valid
   * @param enabled event
   */
  handleButtonStateChange(enabled: boolean) {
    this.buttonEnabledInSubMenu = enabled;
  }
}
